import { colors } from '../../colors';
var address = {
  arrowColor: colors.pinkishRed,
  textColor: colors.black,
  borderColor: colors.black,
  backgroundColor: colors.white
};
export default address;